import { createFileRoute } from '@tanstack/react-router';
import { SettingsScreen } from '@/admin/settings/SettingsScreen';
import { parseSettingsTab, type SettingsTab } from '@/admin/settings/tabs';

export const Route = createFileRoute('/admin/settings')({
  staticData: { minTier: 'ADMIN' },
  validateSearch: (s: Record<string, unknown>): { tab: SettingsTab } => ({
    tab: parseSettingsTab(s.tab),
  }),
  component: SettingsRoute,
});

function SettingsRoute() {
  const { tab } = Route.useSearch();
  return <SettingsScreen tab={tab} />;
}
